import React from 'react'
import NewsletterForm from './NewsletterForm'

const Newsletter = props => {
    return (
        <div className="newsletter">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-5">
                        <div className="section-title-box">
                            <h4 className="section-title">Dołącz do nas</h4>
                            <p className="section-subtitle">Bądź na bieżąco</p>
                        </div>
                        <p className="newsletter__join-us">
                            Dołącz do naszego grona społecznościowego ViaCamp i bądź na bieżąco
                            z nowościami oraz promocjami. Oglądaj filmy i zdjęcia z Twojego
                            pobytu na naszych obozach!
                        </p>
                        <div className="newsletter__socials">
                            <a className="newsletter__social-link" href="https://www.facebook.com/ViaCampPL/" aria-label="Znajdź ViaCamp.pl na facebooku">
                                <span className="icon-facebook newsletter__social-icon"></span>
                            </a>
                            <a className="newsletter__social-link" href="https://www.instagram.com/viacamp.pl/" aria-label="Znajdź ViaCamp.pl na instagramie">
                                <span className="icon-instagram newsletter__social-icon"></span>
                            </a>
                            <a className="newsletter__social-link" href="https://twitter.com/ViaCampPL" aria-label="Znajdź ViaCamp.pl na twitterze">
                                <span className="icon-twitter newsletter__social-icon"></span>
                            </a>
                            <a className="newsletter__social-link" href="https://www.youtube.com/channel/UCReNfMJGDJV_QV6_iSA77nA" aria-label="Znajdź ViaCamp.pl na youtube">
                                <span className="icon-youtube newsletter__social-icon"></span>
                            </a>
                            <a className="newsletter__social-link" href="https://www.snapchat.com/add/viacamp?share_id=OUFGOUM3&locale=pl_PL" aria-label="Znajdź ViaCamp.pl na snapchatcie">
                                <span className="icon-snapchat-ghost newsletter__social-icon"></span>
                            </a>
                        </div>
                    </div>
                    <div className="col-12 col-lg-2">
                        <span className="delimiter"></span>
                    </div>
                    <div className="col-12 col-lg-5">
                        <div className="section-title-box">
                            <h4 className="section-title">Newsletter</h4>
                            <p className="section-subtitle">Nowości z bloga i promocje</p>
                        </div>
                        <NewsletterForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Newsletter
